export const DEFAULT_MAX_REFERRAL_BONUS_AMOUNT_IN_DOLLARS = 150;
export const DEFAULT_REFERRAL_BONUS_AMOUNT_IN_DOLLARS = 50;
